/**
 * /llm — team LLM models (each row = credentials + vendor + API model id).
 *
 * No loader: role comes from the dashboard-shell auth context.
 */

import { PageHeader } from "@/components/page-header";
import { LLMConfigsCard } from "@/features/llm/configs-card";

import { useAuthState } from "../lib/auth";

export default function LlmRoute() {
  const auth = useAuthState();
  const isAdmin = auth.tenant.role === "team_admin";
  return (
    <section className="space-y-4">
      <PageHeader
        eyebrow="workspace"
        title="LLM"
        subtitle="Each model row stores vendor kind, optional base URL, encrypted API key, and the API model id. Agents bind to a row — they do not re-enter keys or vendor settings."
      />
      <LLMConfigsCard isAdmin={isAdmin} />
    </section>
  );
}
